import { dateToString } from '../../../hooks/usePeriodDates/dateToString'

export const getSalesReportDateRange = (startDate?: string, endDate?: string, firstFiscalYearStart?: string) => {
  const salesReportStartDate = startDate ?? (firstFiscalYearStart && dateToString(new Date(firstFiscalYearStart)))
  const salesReportEndDate = endDate || dateToString(new Date())

  return {
    startDate: salesReportStartDate,
    endDate: salesReportEndDate,
  }
}
